import React, { useState, useMemo, useEffect } from "react";
import { Table, Tag, Modal, Button } from "antd";
import { statusList } from "../../../../utils";
import { ExportToExcel } from "../../../../utils";

export const LastOrders = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [exportColumns, setExportColumns] = useState([]);

  const sortedData = useMemo(() => {
    return data
      ? data
        .sort((a, b) => {
          const dateA = new Date(
            a.dateStart?.seconds * 1000 + a.dateStart.nanoseconds / 1000000
          );
          const dateB = new Date(
            b.dateStart?.seconds * 1000 + b.dateStart.nanoseconds / 1000000
          );
          return dateB.getTime() - dateA.getTime();
        })
        .slice(0, 25)
      : [];
  }, [data]);

  const showModal = (items) => {
    const groupedItems = items?.reduce((acc, item) => {
      const existingItem = acc?.find(
        (i) => i.category === item.category && i.brand === item.brand
      );
      if (existingItem) {
        existingItem.quantity += item.quantity;
        existingItem.total += item.total;
      } else {
        acc.push({ ...item });
      }
      return acc;
    }, []);
    setModalData(groupedItems);
    setIsModalVisible(true);
  };

  const columns = [
    {
      title: "Vendedor",
      dataIndex: "seller",
      key: "seller",
    },
    {
      title: "Canal",
      dataIndex: "channel",
      key: "channel",
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      render: (text) => <Tag color={statusList[text].color}>{text}</Tag>,
    },
    {
      title: "Total",
      dataIndex: "saleAmount",
      key: "saleAmount",
      render: (text) => `S/ ${text.toFixed(2)}`,
    },
    {
      title: "Inicio",
      dataIndex: "dateStart",
      key: "dateStart",
      render: (dateStart) => {
        const date = new Date(
          dateStart.seconds * 1000 + dateStart.nanoseconds / 1000000
        );
        return date?.toLocaleString();
      },
    },
    {
      title: "Cierre",
      dataIndex: "dateEnd",
      key: "dateEnd",
      render: (dateEnd) => {
        if (dateEnd === "") return "Sin cierre";
        const date = new Date(
          dateEnd.seconds * 1000 + dateEnd.nanoseconds / 1000000
        );
        return date.toLocaleString();
      },
    },
    {
      title: "Detalles",
      key: "details",
      render: (text, record) => (
        <Button onClick={() => showModal(record.products)} className="btnCancel">
          Detalles
        </Button>
      ),
      width: 120,
    },
  ];

  const columnsDetails = [
    {
      title: "Categoría",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Marca",
      dataIndex: "brand",
      key: "brand",
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (total) => {
        return `S/ ${total.toFixed(2)}`;
      },
    },
  ];

  useEffect(() => {
    const exportData = sortedData?.flatMap((order) => {
      const dateStart = new Date(
        order.dateStart?.seconds * 1000 + order.dateStart.nanoseconds / 1000000
      ).toLocaleString();

      const dateEnd = order.dateEnd
        ? new Date(
          order.dateEnd.seconds * 1000 + order.dateEnd.nanoseconds / 1000000
        ).toLocaleString()
        : "Sin cierre";

      return order.products?.map((item) => ({
        vendedor: order.seller,
        canal: order.channel,
        estado: order.status,
        total: `S/ ${order.saleAmount?.toFixed(2)}`,
        fechaInicio: dateStart,
        fechaCierre: dateEnd,
        categoria: item.category,
        marca: item.brand,
        cantidad: item.quantity,
        totalItem: `S/ ${item.total?.toFixed(2)}`,
      }));
    });

    const exportColumns = [
      { title: "Vendedor", dataIndex: "vendedor", width: 200 },
      { title: "Canal", dataIndex: "canal", width: 200 },
      { title: "Estado", dataIndex: "estado", width: 200 },
      { title: "Total", dataIndex: "total", width: 200 },
      { title: "Fecha de inicio", dataIndex: "fechaInicio", width: 200 },
      { title: "Fecha de cierre", dataIndex: "fechaCierre", width: 200 },
      { title: "Categoria", dataIndex: "categoria", width: 200 },
      { title: "Marca", dataIndex: "marca", width: 200 },
      { title: "Cantidad", dataIndex: "cantidad", width: 200 },
      { title: "Total Item", dataIndex: "totalItem", width: 200 },
    ];

    setExportData(exportData);
    setExportColumns(exportColumns);
  }, [sortedData]);

  return (
    <div className="w-full p-2 lg:p-4">
      <div className="overflow-x-auto h-96">
        <Table
          dataSource={sortedData}
          columns={columns}
          pagination={false}
        />
      </div>
      <Modal
        title="Detalles"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <div className="overflow-x-auto h-96">
          <Table
            dataSource={modalData}
            columns={columnsDetails}
            pagination={false}
          />
        </div>
      </Modal>
      <div
        className="flex justify-end p-2"
      >
        <ExportToExcel
          data={exportData}
          fileName="ultimasOrdenes"
          columns={exportColumns}
        />
      </div>
    </div>
  );
};
